import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { Phone, Mail, Landmark } from "lucide-react";

export default function About() {
  return (
    <section id="ueber-uns" className="py-16 md:py-28" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          number="03"
          eyebrow="Über uns"
          title="Zur Geschichte der Anlage"
        />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <Reveal className="lg:col-span-7 space-y-5 text-base sm:text-lg leading-relaxed text-[#2A332E]">
            <p>
              Rosenthal zählte in früheren Zeiten zu den wohlhabenderen Gemeinden Berlins – und das hatte
              seinen Grund: In den guten Böden in und um Rosenthal war der Anbau von Gemüse und Getreide
              sehr gut möglich. Zur Gemeinde gehörten auch die sogenannten Pfarrwiesen, Grundstücke, welche
              die Pfarrer zur Entlohnung und zur eigenen Bewirtschaftung erhielten.
            </p>
            <p>
              Der Pfarrer <strong className="text-[#1A382B]">Günther Schönwald</strong>, dessen Name unsere
              Gartenanlage heute trägt, ließ seine Pfarrwiesen <strong className="text-[#1A382B]">1918</strong> parzellieren
              und gab sie in Zeiten großer Not für eine sehr geringe Pacht an Soldatenwitwen zur
              Selbstversorgung ab.
            </p>
            <p>
              In den vielen Jahren bis heute entwickelte sich die Gartenanlage „Schönwald" zu einer
              gepflegten und beliebten Gartenanlage am Rande Berlins. Sie ist im Besitz der Kirchengemeinde
              Berlin-Rosenthal und wird durch das Kirchliche Verwaltungsamt Berlin Mitte-Nord verwaltet.
            </p>
          </Reveal>

          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="rounded-2xl border border-[#D8D3C5] bg-white p-7 shadow-[0_18px_40px_rgba(26,56,43,0.08)]" data-testid="kva-notice-card">
              <div className="flex items-center gap-3 mb-4">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#E2ECE5] text-[#1A382B]">
                  <Landmark size={20} strokeWidth={1.8} />
                </span>
                <h3 className="font-display text-xl sm:text-2xl font-semibold text-[#1A382B]">
                  Wichtiger Hinweis zur Parzellenvergabe
                </h3>
              </div>
              <p className="text-sm sm:text-base leading-relaxed text-[#47544A]">
                Für Anfragen zur Vergabe von Parzellen ist einzig und allein das
                <strong> Kirchliche Verwaltungsamt Berlin Mitte Nord (KVA)</strong> zuständig.
              </p>
              <div className="mt-5 space-y-2.5 text-sm sm:text-base">
                <p className="font-semibold text-[#1A382B]">KVA Immobilienmanagement · Herr Wittig</p>
                <a href="tel:+4930258185226" data-testid="kva-phone-link" className="flex items-center gap-2 text-[#2A332E] hover:text-[#C85A32] transition-colors">
                  <Phone size={15} className="text-[#5A826B]" /> 030 2581 85 226
                </a>
                <a href="mailto:B.Wittig@kva-bmn.de" data-testid="kva-mail-link" className="flex items-center gap-2 text-[#2A332E] hover:text-[#C85A32] transition-colors">
                  <Mail size={15} className="text-[#5A826B]" /> B.Wittig@kva-bmn.de
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
